// @flow

import { initAppActions } from './initServiceActionCreator';
import { isArrayNonEmpty } from '../helpers';
import { PathsWithoutHeaders } from './Constants';
import openUrls from '../../services/openUrls';

const initialState = {
  pincode: null,
  pincodeproto: null,
  mobileNumber: null,
  mobileNumberproto: null,
  panNumber: null,
  panNumberproto: null,
  gstIn: null,
  gstInproto: null,
  fetchingLocations: null,
  locationList: [],
  zoneTypeList: [],
  reasonList: [],
  isRedirectedFromRivigo: false,
  hideHeader: false,
  isExternalRoute: false,
  directDeliveryCount: null
};

const initServiceReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case initAppActions.SET_PROTOS:
      return Object.assign({}, state, action.payload);
    case initAppActions.GET_LOCATIONS:
      if (isArrayNonEmpty(action.payload.locationList)) {
        try {
          sessionStorage.setItem(
            'locationList',
            JSON.stringify(action.payload.locationList)
          );
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('Could not save locations list in session storage');
        }
      }
      return Object.assign({}, state, action.payload);
    case initAppActions.GET_DIRECT_DELIVERY_COUNT:
      let data = '';
      if (!action.payload) {
        return Object.assign({}, state);
      }
      if (
        action.payload.directDeliveryCount ||
        action.payload.directDeliveryCount === 0
      ) {
        data = action.payload.directDeliveryCount.toString();
      }
      return Object.assign({}, state, { directDeliveryCount: data });
    case initAppActions.GET_SHOPFLOOR_ZONE_TYPES:
      if (isArrayNonEmpty(action.payload.zoneTypeList)) {
        try {
          sessionStorage.setItem(
            'zoneTypeList',
            JSON.stringify(action.payload.zoneTypeList)
          );
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('Could not save shop floor types in session storage');
        }
      }
      return Object.assign({}, state, action.payload);

    case initAppActions.SET_ROUTE_SPECIFIC_FLAGS: {
      const isRedirectedFromRivigo = action.payload.search.includes(
        'redirectedFromRivigo=true'
      );
      const hideHeader = PathsWithoutHeaders.includes(action.payload.pathname);
      const isExternalRoute = openUrls.includes(action.payload.pathname);
      const newState = Object.assign({}, state, {
        isRedirectedFromRivigo,
        hideHeader,
        isExternalRoute
      });
      return newState;
    }

    case initAppActions.GET_REASONS:
      if (isArrayNonEmpty(action.payload.reasonList)) {
        try {
          sessionStorage.setItem(
            'reasonList',
            JSON.stringify(action.payload.reasonList)
          );
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('Could not save reasons list in session storage');
        }
      }
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
};

export default initServiceReducer;
